import { useState, useEffect } from 'react';

export const useIsMobile = (mobileWidth = 768) => {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= mobileWidth;
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= mobileWidth);
      };

      checkMobile();

      const handleResize = (() => {
        let timeout: NodeJS.Timeout;
        return () => {
          clearTimeout(timeout);
          timeout = setTimeout(checkMobile, 300);
        };
      })();

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [mobileWidth]);

  return isMobile;
};
